import { useEffect, useState } from "react"

import { useEvent } from "./useEvent"

export interface Options {
  onFocus?: (e: FocusEvent) => void
  onBlur?: (e: FocusEvent) => void
  onChange?: (isFocusWithin: boolean) => void
}

export function useFocusWithin(target: HTMLElement | null, options?: Options) {
  const [isFocusWithin, setIsFocusWithin] = useState(false)
  const { onFocus, onBlur, onChange } = options || {}

  const handleFocusIn = useEvent((e: FocusEvent) => {
    if (!isFocusWithin) {
      onFocus?.(e)
      onChange?.(true)
      setIsFocusWithin(true)
    }
  })

  const handleFocusOut = useEvent((e: FocusEvent) => {
    if (
      isFocusWithin &&
      !(e.currentTarget as Element)?.contains?.(e.relatedTarget as Element) &&
      e.relatedTarget !== target
    ) {
      onBlur?.(e)
      onChange?.(false)
      setIsFocusWithin(false)
    }
  })

  useEffect(() => {
    target?.addEventListener("focusin", handleFocusIn)
    target?.addEventListener("focusout", handleFocusOut)
    return () => {
      target?.removeEventListener("focusin", handleFocusIn)
      target?.removeEventListener("focusout", handleFocusOut)
    }
  }, [target])

  return isFocusWithin
}
